<div class="table-wrapper">
	<table *ngIf="!loading && dashboardSettings && accessibility; else contentLoader">
		<thead>
			<tr>
				<th scope="col"></th>
				<div class="inline" *ngFor="let item of dashboardSettings">
					<th *ngIf="item.value === 'date'" scope="col" i18n="tchek-list|@@date">Date</th>
					<th *ngIf="item.value === 'scanner'" scope="col" i18n="tchek-list|@@scanner">Borne</th>
					<th *ngIf="item.value === 'picture'" scope="col" i18n="tchek-list|@@picture">Photo</th>
					<th *ngIf="item.value === 'status'" scope="col" i18n="tchek-list|@@status">Statut</th>
					<th *ngIf="item.value === 'brand'" scope="col" i18n="tchek-list|@@brand">Marque</th>
					<th *ngIf="item.value === 'model'" scope="col" i18n="tchek-list|@@model">Modèle</th>
					<th *ngIf="item.value === 'fre'" scope="col" i18n="tchek-list|@@repair_cost">FRE</th>
					<th *ngIf="item.value === 'newFre'" scope="col" i18n="tchek-list|@@repair_new_cost">Nouveau FRE</th>
					<th *ngIf="item.value === 'speed'" scope="col" i18n="tchek-list|@@speed">Speed</th>
					<!-- TODO: add this class when implemented: d-xl-table-cell -->
					<th *ngIf="item.value === 'dirt'" scope="col" class="d-none" i18n="tchek-list|@@dirt">Saleté</th>
					<!-- TODO: add this class when implemented: d-xl-table-cell -->
					<th *ngIf="item.value === 'matriculation'" scope="col" i18n="tchek-list|@@matriculation">Immat</th>
					<th *ngIf="item.value === 'orNumber' && vehicleSettings.orNumber" scope="col"
						i18n="tchek-list|@@repair_number">O.R.</th>
					<th *ngIf="item.value === 'vinNumber' && vehicleSettings.vinNumber" scope="col">V.I.N.</th>
					<th *ngIf="item.value === 'newDamage'" scope="col" i18n="tchek-list|@@new_damages">Nouveaux dommages
					</th>
					<th *ngIf="item.value === 'damage'" scope="col" i18n="tchek-list|@@damages">Dommages</th>
					<th *ngIf="item.value === 'type' && isSuperAdmin" scope="col" i18n="tchek-list|@@type">Type</th>
				</div>
				<th i18n="tchek-list|@@actions" scope="col">Actions</th>
			</tr>
		</thead>
		<tbody>
			<tr #row *ngFor="let tchek of tcheks" [ngClass]="{'unread': tchek?.isNew}"
				(mouseenter)="row.classList.add('row-hover')" (mouseleave)="row.classList.remove('row-hover')"
				(click)="handleRowClick($event, tchek)">
				<td>
					<span class="row-icon" *ngIf="tchek?.isFlagged; else rowIconNotFlagged"
						(click)="handleSetAsUnflagged($event, tchek)">
						<img src='../../../assets/icon/warning.svg' />
					</span>
					<ng-template #rowIconNotFlagged>
						<span class='row-icon'
							[ngClass]="{'row-icon row-icon-hiden': accessibility.showIcons === false && !row.classList.contains('row-hover')}"
							(click)="handleSetAsFlagged($event, tchek)">
							<img src='../../../assets/icon/warning-outline.svg' style="cursor: pointer;" />
						</span>
					</ng-template>

					<span class="row-icon" *ngIf="tchek?.isNew; else rowIconRead"
						(click)="handleSetAsRead($event, tchek)">
						<img src='../../../assets/icon/notread.svg' />
					</span>
					<ng-template #rowIconRead>
						<span class="row-icon" (click)="handleSetAsUnread($event, tchek)">
							<img src='../../../assets/icon/read.svg' />
						</span>
					</ng-template>


					<div class="col-12">
						<span class='row-icon' *ngIf="tchek?.inspected === true; else rowIconInspected"
							(click)="handleSetAsUnInspected($event, tchek)">
							<img src='../../../assets/icon/search_filled.svg' style="width: 18px; height: 18px;" />
						</span>
						<ng-template #rowIconInspected>
							<span class='row-icon'
								[ngClass]="{'row-icon row-icon-hiden': accessibility.showIcons === false && !row.classList.contains('row-hover')}"
								(click)="handleSetAsInspected($event, tchek)" style="cursor: pointer;">
								<img src='../../../assets/icon/search_not_filled.svg'
									style="width: 18px; height: 18px;" />
							</span>
						</ng-template>
					</div>


					<div *ngIf="isSuperAdmin">
						<span class='row-icon' *ngIf="tchek?.kpi === true; else rowIconKpi"
							(click)="handleSetKpi($event, tchek, false)">
							<img src='../../../assets/icon/kpi_filled.svg' style="width: 18px; height: 18px;" />
						</span>

						<ng-template #rowIconKpi>
							<span class='row-icon'
								[ngClass]="{'row-icon row-icon-hiden': accessibility.showIcons === false && !row.classList.contains('row-hover')}"
								(click)="handleSetKpi($event, tchek, true)" style="cursor: pointer;">
								<img src='../../../assets/icon/kpi_not_filled.svg' style="width: 18px; height: 18px;" />
							</span>
						</ng-template>
					</div>

					<span class='row-icon' *ngIf="tchek.type < 2">
						<button
							*ngIf="(isSuperAdmin || companyname === 'Europcar') && isLocal === false && tchek.isUploaded !== true"
							class="uploadToCloud" (click)="handleRequestVideoTchek($event, tchek)"
							style="color: black;cursor: pointer;">
							<i class="fa fa-download"
								[ngClass]="{'hiddenVisibility': accessibility.showIcons === false && !row.classList.contains('row-hover')}"
								*ngIf="tchek.isUploaded === undefined"></i>
							<i class='fa fa-circle-o-notch fa-spin' *ngIf="tchek.isUploaded === false"></i>
						</button>


						<button
							*ngIf="isSuperAdmin && isLocal === false && tchek.scanToUpload !== false  && tchek.isUploaded  "
							class="uploadToCloud" (click)="handleRequestHdTchek($event, tchek)"
							style="color: black;cursor: pointer;">
							<i class="fa fa-cloud-upload"
								[ngClass]="{'hiddenVisibility': accessibility.showIcons === false && !row.classList.contains('row-hover')}"
								*ngIf="(tchek.toDownload !== 1 && !tchek.uploadHDPictures && tchek.videoConverter !== 2)"></i>
							<i class="fa fa-cloud" aria-hidden="true"
								*ngIf="tchek.uploadHDPictures && tchek.videoConverter === 2 && tchek.toDownload !== 1"
								style="color: Tomato;"></i>
							<i class='fa fa-circle-o-notch fa-spin' *ngIf="tchek.toDownload === 1"></i>
							<i class="fa fa-cloud" aria-hidden="true"
								*ngIf="tchek.uploadHDPictures && tchek.videoConverter !== 2 && tchek.toDownload !== 1"></i>
						</button>

						<button
							*ngIf="tchek.isUploaded  && isSuperAdmin && !tchek.uploadHDPictures &&  tchek.toDownload !== 1 &&  tchek.scanToUpload !== false &&  (isLocal === false || tchek.isDeletedLocal !== true) "
							class="uploadToCloud" (click)="handleRequestExtractVideo($event, tchek)"
							style="color: black;cursor: pointer;">
							<i class="fa fa-camera  "
								[ngClass]="{'hiddenVisibility': accessibility.showIcons === false && !row.classList.contains('row-hover')}"
								*ngIf="tchek.videoConverter !== 1 && tchek.videoConverter !== 2"></i>
							<i class='fa fa-circle-o-notch fa-spin' *ngIf="tchek.videoConverter ===1"></i>
							<i class="fa fa-image" aria-hidden="true" *ngIf="tchek.videoConverter === 2"></i>
						</button>
					</span>

				</td>

				<div class="inline" *ngFor="let item of dashboardSettings">
					<td *ngIf="item.value === 'picture'">

						<!-- mini  -->
						<img *ngIf="(tchek?.isUploaded || tchek.thumbnailPicture || isLocal )&& !tchek.thumbnailImagePtr  "
							class="row-thumbnail" [src]="tchek?.thumbnailUrl" alt="Tchek thumbnail"
							(error)="handleImageError($event)" title="{{tchek?.tchekCreatedAt | date:'short':'':'fr'}}">
						<!-- mini  -->
						<img *ngIf="tchek.thumbnailImagePtr && tchek.thumbnailImagePtr.file" class="row-thumbnail"
							[src]="tchek.thumbnailImagePtr.file.url()" alt="Tchek thumbnail"
							(error)="handleImageError($event)" title="{{tchek?.tchekCreatedAt | date:'short':'':'fr'}}">
						<img *ngIf="tchek.thumbnailImagePtr && !tchek.thumbnailImagePtr.file" class="row-thumbnail"
							[src]="cloudFrontImage(tchek) || '../../../assets/images/sdk.png'" alt="Tchek thumbnail"
							title="{{tchek?.tchekCreatedAt | date:'short':'':'fr'}}">

						<!-- loading  -->
						<img *ngIf="(!tchek?.isUploaded && !tchek.thumbnailPicture && !tchek.thumbnailImagePtr)&& !isLocal"
							class="row-thumbnail row-thumbnail-error" style="width: 120px;" src="assets/icon/uploading2x.png"
							alt="Tchek thumbnail" title=" {{tchek?.tchekCreatedAt | date:'short':'':'fr'}}">

						<!-- immat -->
						<img *ngIf="isSuperAdmin && tchek.immatUrl && accessibility && accessibility.showImmatPicture"
							class="row-thumbnail" [src]="tchek?.immatUrl" alt="Tchek thumbnail"
							(error)="handleImageError($event)" title="{{tchek?.tchekCreatedAt | date:'short':'':'fr'}}"
							style="height: 39px;">

					</td>

					<td *ngIf="item.value === 'type'&& isSuperAdmin">
						{{typeOfTchek[tchek.type]}}
					</td>

					<td *ngIf="item.value === 'matriculation'" (click)="stopPropa($event)">
						<textarea placeholder="-" spellcheck="false" maxlength="17" [ngModel]="tchek.vehiclePtr.immat | uppercase"
							(ngModelChange)="saveVehicle($event, tchek, 'immat')"></textarea>
					</td>
					<td *ngIf="item.value === 'newDamage'" class="d-none">12</td>
					<!-- TODO: add this class when implemented: d-xl-table-cell -->
					<td *ngIf="item.value === 'damage'">
						<ng-container
							*ngIf="(tchek.toAnalyze && !tchek.detectionFinished) || !canDetection; else elseTemplate">
							-
						</ng-container>
						<ng-template #elseTemplate>
							<img *ngIf="tchek.detectionStatus === false"
								src="../../../assets/icon/alert_empty.svg" style="width: 30px; height : 30px;">
							{{tchek.detectionStatus === false ? '': (tchek?.numberDamage ===
							undefined?
							'0' :
							tchek.numberDamage)}}
						</ng-template>
					</td>
					<td *ngIf="item.value === 'newDamage'">
						<ng-container
							*ngIf="(tchek.toAnalyze && !tchek.detectionFinished) || !canDetection; else elseTemplate">
							-
						</ng-container>
						<ng-template #elseTemplate>
							<div
								[ngClass]="{'redRound': tchek.numberNewDamage !== undefined && tchek.numberNewDamage >  0}">
								{{tchek?.numberNewDamage === undefined? '-' : tchek.numberNewDamage}}
							</div>

						</ng-template>
					</td>

					<td *ngIf=" item.value==='orNumber' && vehicleSettings.orNumber" (click)="stopPropa($event)">
						<textarea class="first" placeholder="-" spellcheck="false" maxlength="17"
							[ngModel]="tchek.vehiclePtr.or"
							(ngModelChange)="saveVehicle($event, tchek, 'or')"></textarea>
					</td>
					<td *ngIf="item.value === 'vinNumber' && vehicleSettings.vinNumber" (click)="stopPropa($event)">
						<textarea placeholder="-" spellcheck="false" maxlength="17" [ngModel]="tchek.vehiclePtr.vin"
							(ngModelChange)="saveVehicle($event, tchek, 'vin')"></textarea>
					</td>

					<td *ngIf="item.value === 'status'">
						<div *ngIf="!tchek.toAnalyze || tchek.detectionFinished">{{tchek?.status | tchekStatus}}</div>
						<div *ngIf="tchek.toAnalyze && !tchek.detectionFinished && tchek.percentDamage == 0"
							i18n="tchek-list|@@pending">En attente</div>
						<div class="tchek.toAnalyze && progress mt-10"
							*ngIf="!tchek.detectionFinished && tchek.percentDamage > 0">
							<div class="progress-bar " role="progressbar" aria-valuemin="0" aria-valuemax="100"
								[style.width.%]="tchek.percentDamage"></div>
						</div>
					</td>
					<td *ngIf="item.value === 'date' ">{{tchek?.tchekCreatedAt | date:'short':'':'fr'}}</td>
					<td *ngIf="item.value === 'scanner'">{{tchek?.devicePtr?.serialNumber || '-'}}</td>
					<td *ngIf="item.value === 'brand'">{{tchek?.vehiclePtr?.brand || '-'}}</td>
					<td *ngIf="item.value === 'model'" (click)="stopPropa($event)">
						<textarea placeholder="-" spellcheck="false" maxlength="17" [ngModel]="tchek.vehiclePtr.model"
							(ngModelChange)="saveVehicle($event, tchek, 'model')"></textarea>
					</td>
					<td *ngIf="item.value === 'fre'">{{tchek?.fre ? tchek?.fre + ' €' : '-'}}</td>
					<td *ngIf="item.value === 'newFre'">{{tchek?.newFre ? tchek?.newFre + ' €' : '-'}}</td>
					<td *ngIf="item.value === 'speed'">{{tchek?.speed ? tchek?.speed  : '-'}}</td>
					<!-- TODO: add this class when implemented: d-xl-table-cell -->
					<td *ngIf="item.value === 'dirt'" class="d-none">10%</td>
					<!-- TODO: add this class when implemented: d-xl-table-cell -->

				</div>

				<td>
					<app-submenu [options]="[4,5].includes(tchek.type) ||(tchek.type === 0 && (this.isSuperAdmin || this.companyname=='BCA_Scan')) ? submenuOptions2 : submenuOptions"
						(selectedOption)="handleSubmenuSelection($event, tchek)">
						<div class="button-no-style" style="cursor: pointer;">
							<svg width="4px" height="16px" viewBox="0 0 4 16" version="1.1"
								xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
								<title>Plus...</title>
								<desc>Created with Sketch.</desc>
								<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
									<g id="UI-Rapport" transform="translate(-1231.000000, -191.000000)" fill="#162C4B"
										fill-rule="nonzero">
										<g id="Header-Small" transform="translate(165.000000, 153.000000)">
											<g id="CTA" transform="translate(1050.000000, 23.000000)">
												<g id="menu-dots"
													transform="translate(18.000000, 23.000000) rotate(90.000000) translate(-18.000000, -23.000000) translate(10.000000, 21.000000)">
													<circle id="Oval" cx="8" cy="2" r="2"></circle>
													<circle id="Oval" cx="2" cy="2" r="2"></circle>
													<circle id="Oval" cx="14" cy="2" r="2"></circle>
												</g>
											</g>
										</g>
									</g>
								</g>
							</svg>
						</div>
					</app-submenu>

					<ng-template #modalDelete>
						<div class="modal-body">
							<div class="container">
								<div class="row">
									<div class="col-12">
										<img src="../../../assets/icon/close-modal.svg" class="close" aria-label="Close"
											(click)="modalDeleteRef.dismiss('Cross click')" />
									</div>
								</div>
								<div class="row titleRow">
									<div class="col-12">
										<span class="title" i18n="modal_deletTchek|@@reasonLineTitle">Quel est le motif
											de suppression de ce
											scan
											?</span>
									</div>
								</div>
								<div class="row">
									<div class="col-12">
										<div class="line">
											<input type="text" id='modalInput' style="text-align:left"
												placeholder="Doublon / faux scan ..."
												i18n-placeholder="modal_deletTchek|@@reasonEx" [(ngModel)]="reason">
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-lg primary" i18n="modal_damage|@@cancel"
								(click)="modalDeleteRef.dismiss('Cross click')">Annuler</button>
							<button *ngIf="reason.length > 0" type="button" class="btn btn-lg primary"
								i18n="modal_deletTchek|@@delete" (click)="saveModal()">Supprimer</button>
							<button *ngIf="reason.length === 0" type="button" style="background-color: #DBDCE0;"
								class="btn btn-lg secondary" i18n="modal_deletTchek|@@delete">Supprimer</button>
						</div>
					</ng-template>


				</td>
			</tr>
		</tbody>
	</table>
</div>

<ng-template #contentLoader>
	<table>
		<thead>
			<tr>
				<th scope="col"></th>
				<th scope="col" i18n="tchek-list|@@picture">Photo</th>
				<th scope="col" i18n="tchek-list|@@matriculation">Immat</th>
				<th scope="col" i18n="tchek-list|@@damages">Dommages</th>
				<th scope="col" i18n="tchek-list|@@status">Statut</th>
				<th scope="col" i18n="tchek-list|@@brand">Marque</th>
				<th scope="col" i18n="tchek-list|@@model">Modèle</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td>
					<span class="row-icon">
						<svg width="15px" height="16px" viewBox="0 0 15 16" version="1.1"
							xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						</svg>
					</span>
					<span class="row-icon"><svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1"
							xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						</svg>
					</span>
				</td>
				<td>
					<content-loader [primaryOpacity]="1" [secondaryOpacity]="1" [width]="120" [height]="85">
						<svg:rect id="rect3686" width="120px" height="85px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="1" [secondaryOpacity]="1" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="1" [secondaryOpacity]="1" [width]="120" [height]="15">
						<svg:rect id="rect3686" width="120px" height="15px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="1" [secondaryOpacity]="1" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="1" [secondaryOpacity]="1" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="1" [secondaryOpacity]="1" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
			</tr>
			<tr>
				<td>
					<span class="row-icon">
						<svg width="15px" height="16px" viewBox="0 0 15 16" version="1.1"
							xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						</svg>
					</span>
					<span class="row-icon"><svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1"
							xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						</svg>
					</span>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.9" [secondaryOpacity]="0.9" [width]="120" [height]="85">
						<svg:rect id="rect3686" width="120px" height="85px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.9" [secondaryOpacity]="0.9" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.9" [secondaryOpacity]="0.9" [width]="120" [height]="15">
						<svg:rect id="rect3686" width="120px" height="15px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.9" [secondaryOpacity]="0.9" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.9" [secondaryOpacity]="0.9" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.9" [secondaryOpacity]="0.9" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
			</tr>
			<tr>
				<td>
					<span class="row-icon">
						<svg width="15px" height="16px" viewBox="0 0 15 16" version="1.1"
							xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						</svg>
					</span>
					<span class="row-icon"><svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1"
							xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						</svg>
					</span>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.8" [secondaryOpacity]="0.8" [width]="120" [height]="85">
						<svg:rect id="rect3686" width="120px" height="85px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.8" [secondaryOpacity]="0.8" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.8" [secondaryOpacity]="0.8" [width]="120" [height]="15">
						<svg:rect id="rect3686" width="120px" height="15px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.8" [secondaryOpacity]="0.8" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.8" [secondaryOpacity]="0.8" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.8" [secondaryOpacity]="0.8" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
			</tr>
			<tr>
				<td>
					<span class="row-icon">
						<svg width="15px" height="16px" viewBox="0 0 15 16" version="1.1"
							xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						</svg>
					</span>
					<span class="row-icon"><svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1"
							xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						</svg>
					</span>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.7" [secondaryOpacity]="0.7" [width]="120" [height]="85">
						<svg:rect id="rect3686" width="120px" height="85px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.7" [secondaryOpacity]="0.7" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.7" [secondaryOpacity]="0.7" [width]="120" [height]="15">
						<svg:rect id="rect3686" width="120px" height="15px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.7" [secondaryOpacity]="0.7" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.7" [secondaryOpacity]="0.7" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.7" [secondaryOpacity]="0.7" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
			</tr>
			<tr>
				<td>
					<span class="row-icon">
						<svg width="15px" height="16px" viewBox="0 0 15 16" version="1.1"
							xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						</svg>
					</span>
					<span class="row-icon"><svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1"
							xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						</svg>
					</span>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.6" [secondaryOpacity]="0.6" [width]="120" [height]="85">
						<svg:rect id="rect3686" width="120px" height="85px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.6" [secondaryOpacity]="0.6" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.6" [secondaryOpacity]="0.6" [width]="120" [height]="15">
						<svg:rect id="rect3686" width="120px" height="15px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.6" [secondaryOpacity]="0.6" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.6" [secondaryOpacity]="0.6" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.6" [secondaryOpacity]="0.6" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
			</tr>
			<tr>
				<td>
					<span class="row-icon">
						<svg width="15px" height="16px" viewBox="0 0 15 16" version="1.1"
							xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						</svg>
					</span>
					<span class="row-icon"><svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1"
							xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						</svg>
					</span>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.4" [secondaryOpacity]="0.4" [width]="120" [height]="85">
						<svg:rect id="rect3686" width="120px" height="85px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.4" [secondaryOpacity]="0.4" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.4" [secondaryOpacity]="0.4" [width]="120" [height]="15">
						<svg:rect id="rect3686" width="120px" height="15px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.4" [secondaryOpacity]="0.4" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.4" [secondaryOpacity]="0.4" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.4" [secondaryOpacity]="0.4" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
			</tr>
			<tr>
				<td>
					<span class="row-icon">
						<svg width="15px" height="16px" viewBox="0 0 15 16" version="1.1"
							xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						</svg>
					</span>
					<span class="row-icon"><svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1"
							xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						</svg>
					</span>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.2" [secondaryOpacity]="0.2" [width]="120" [height]="85">
						<svg:rect id="rect3686" width="120px" height="85px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.2" [secondaryOpacity]="0.2" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.2" [secondaryOpacity]="0.2" [width]="120" [height]="15">
						<svg:rect id="rect3686" width="120px" height="15px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.2" [secondaryOpacity]="0.2" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.2" [secondaryOpacity]="0.2" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.2" [secondaryOpacity]="0.2" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
			</tr>
			<tr>
				<td>
					<span class="row-icon">
						<svg width="15px" height="16px" viewBox="0 0 15 16" version="1.1"
							xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						</svg>
					</span>
					<span class="row-icon"><svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1"
							xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						</svg>
					</span>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.1" [secondaryOpacity]="0.1" [width]="120" [height]="85">
						<svg:rect id="rect3686" width="120px" height="85px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.1" [secondaryOpacity]="0.1" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.1" [secondaryOpacity]="0.1" [width]="120" [height]="15">
						<svg:rect id="rect3686" width="120px" height="15px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.1" [secondaryOpacity]="0.1" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.1" [secondaryOpacity]="0.1" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
				<td>
					<content-loader [primaryOpacity]="0.1" [secondaryOpacity]="0.1" [width]="120" [height]="20">
						<svg:rect id="rect3686" width="120px" height="20px" x="0" y="0" rx="3" ry="3"
							style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
					</content-loader>
				</td>
			</tr>
		</tbody>
	</table>
</ng-template>


// WEBPACK FOOTER //
// ./src/app/element/tchek-list/tchek-list.component.html